import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=d5e75488&scoped=true&"
import script from "./TakePhoto.vue?vue&type=script&lang=js&"
export * from "./TakePhoto.vue?vue&type=script&lang=js&"
import style0 from "./TakePhoto.vue?vue&type=style&index=0&id=d5e75488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e75488",
  null
  
)

export default component.exports